// tabs.js
document.addEventListener('DOMContentLoaded', () => {
  const tabsNav = document.querySelectorAll('.tabs-nav li');
  const tabsContent = document.querySelectorAll('.tab-content');
  const scrollToTabLink = document.querySelector('.scroll-to-tab');

  // Handle tab switching
  tabsNav.forEach(tab => {
    tab.addEventListener('click', () => {
      // Remove active class from all tabs and contents
      tabsNav.forEach(nav => nav.classList.remove('active'));
      tabsContent.forEach(content => content.classList.remove('active'));

      // Add active class to the clicked tab and corresponding content
      tab.classList.add('active');
      document.getElementById(tab.dataset.tab).classList.add('active');
    });
  });

  // Handle smooth scrolling and tab activation for the link
  if (scrollToTabLink) {
    scrollToTabLink.addEventListener('click', (e) => {
      e.preventDefault();

      // Scroll to the description tab
      const descriptionTab = document.getElementById('description');
      const descriptionNav = document.querySelector('.tabs-nav li[data-tab="description"]');
      descriptionTab.scrollIntoView({ behavior: 'smooth' });

      // Activate the description tab
      tabsNav.forEach(nav => nav.classList.remove('active'));
      tabsContent.forEach(content => content.classList.remove('active'));
      descriptionNav.classList.add('active');
      descriptionTab.classList.add('active');
    });
  }
});
